export default __webpack_public_path__ + "static/media/bam_bg.06fdb735.jpg";